"use strict";

Shopify.theme.jsFeaturedCollection = {
	init: function init($section) {
		Shopify.theme.jsFeaturedCollection = $.extend(
			this,
			Shopify.theme.getSectionData($section)
		);

		if (
			this.enable_masonry_layout &&
			!this.align_height &&
			this.collection_style == "grid"
		) {
			Shopify.theme.applyMasonry();
		}

		if (this.collection_style == "slider") {
			this.handleResponsiveSlider();
			$(window).on(
				"resize.featuredCollection",
				this.handleResponsiveSlider.bind(this)
			);
		}
	},

	isMobile: function isMobile() {
		return window.matchMedia("(max-width: 767px)").matches;
	},

	handleResponsiveSlider: function handleResponsiveSlider() {
		var $slider = $(".featured-collection.layout--slider .slider-gallery");

		if (this.isMobile()) {
			// Destroy slider on mobile
			if ($slider.hasClass("flickity-enabled")) {
				this._clearFocusState($slider);
				$slider.flickity("destroy");
			}
		} else {
			// Initialize slider on tablet and up
			if (!$slider.hasClass("flickity-enabled")) {
				this.createSlider();
			}
		}
	},

	createSlider: function createSlider() {
		var $slider = $(".featured-collection.layout--slider .slider-gallery");
		var slideData = {
			products_per_slide: this.products_per,
			products_available: this.products_available,
			products_limit: this.products_limit,
			cellAlign: "left",
			wrapAround: true,
		};

		$slider.flickity({
			lazyLoad: 2,
			freeScroll: true,
			imagesLoaded: true,
			cellAlign: "left",
			wrapAround: slideData.wrapAround,
			pageDots: false,
			contain: true,
			prevNextButtons:
				slideData.products_limit > slideData.products_per_slide,
			initialIndex: 0,
			arrowShape: arrowShape,
			on: {
				ready: function () {
					requestAnimationFrame(function () {
						$slider.flickity("resize");
					});
					setTimeout(function () {
						$slider.flickity("resize");
					}, 100);
					// a11y state on first render
					console.log('DEBUG: Initial _updateSlideFocusState call on ready');
					Shopify.theme.jsFeaturedCollection._updateSlideFocusState(
						$slider
					);
					// keep states in sync
					$slider.on(
						"select.flickity settle.flickity change.flickity",
						function () {
							console.log('DEBUG: _updateSlideFocusState call on flickity event');
							Shopify.theme.jsFeaturedCollection._updateSlideFocusState(
								$slider
							);
						}
					);
				},
			},
		});

		// Fallback: ensure layout after all images
		$(window).on("load.featuredCollection", function () {
			if ($slider.hasClass("flickity-enabled")) $slider.flickity("resize");
		});
	},

	// ------- A11y helpers (same pattern as before) -------
	_FOCUSABLE_SEL:
		'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])',

	_updateSlideFocusState: function ($slider) {
		// Get Flickity instance
		var flickity = $slider.data('flickity');
		if (!flickity) {
			console.log('DEBUG: No flickity instance found');
			return;
		}

		// Calculate visible cells based on slider position and viewport
		var sliderWidth = $slider.width();
		var selectedIndex = flickity.selectedIndex;
		
		// Get actual cell width from the DOM element
		var $firstCell = $slider.find('.flickity-slider > *').first();
		var cellWidth = $firstCell.length ? $firstCell.outerWidth(true) : 0;
		
		// Fallback: if still no width, estimate based on products_per setting
		if (!cellWidth && this.products_per) {
			cellWidth = sliderWidth / this.products_per;
		}
		
		// Final fallback: assume 4 products per slide if no other data
		if (!cellWidth) {
			cellWidth = sliderWidth / 4;
		}

		// Estimate how many cells can fit in the viewport
		var visibleCellsCount = Math.ceil(sliderWidth / cellWidth);
		var visibleIndexes = [];
		
		// Generate array of visible cell indexes
		for (var i = 0; i < visibleCellsCount && (selectedIndex + i) < flickity.cells.length; i++) {
			visibleIndexes.push(selectedIndex + i);
		}

		console.log('DEBUG: Slider width:', sliderWidth);
		console.log('DEBUG: Cell width:', cellWidth);
		console.log('DEBUG: Selected index:', selectedIndex);
		console.log('DEBUG: Estimated visible cells count:', visibleCellsCount);
		console.log('DEBUG: Visible cell indexes:', visibleIndexes);
		console.log('DEBUG: Total cells:', flickity.cells.length);

		// Scope to this Flickity instance only
		$slider.find(".flickity-slider > *").each((index, el) => {
			var $cell = $(el);
			var isVisible = visibleIndexes.indexOf(index) !== -1;
			var $focusables = $cell.find(this._FOCUSABLE_SEL);
			var currentAriaHidden = $cell.attr("aria-hidden");
			var currentInert = $cell.prop("inert");

			console.log(`DEBUG: Cell ${index} - isVisible: ${isVisible}, current aria-hidden: ${currentAriaHidden}, current inert: ${currentInert}`);

			if (!isVisible) {
				// Hide non-visible slides
				$cell.prop("inert", true);
				$cell.attr("aria-hidden", "true");

				$focusables.each((__, f) => {
					var $f = $(f);
					if ($f.attr("tabindex") !== "-1") $f.attr("tabindex", "-1");
					if ($f.attr("aria-hidden") !== "true")
						$f.attr("aria-hidden", "true");
				});
				console.log(`DEBUG: Cell ${index} - SET TO HIDDEN (aria-hidden: true, inert: true)`);
			} else {
				// Show visible slides
				$cell.prop("inert", false);
				$cell.removeAttr("aria-hidden");

				$focusables.each((__, f) => {
					var $f = $(f);
					if ($f.attr("tabindex") === "-1") $f.removeAttr("tabindex");
					if ($f.attr("aria-hidden") === "true")
						$f.removeAttr("aria-hidden");
				});
				console.log(`DEBUG: Cell ${index} - SET TO VISIBLE (aria-hidden: removed, inert: false)`);
			}
		});
	},

	_clearFocusState: function ($slider) {
		// Remove anything we added before destroying/unmounting
		$slider.find(".flickity-slider > *").each((_, el) => {
			var $cell = $(el);
			$cell.prop("inert", false);
			// Alternative: $cell.removeAttr("inert");

			$cell.find(this._FOCUSABLE_SEL).each((__, f) => {
				var $f = $(f);
				if ($f.attr("tabindex") === "-1") $f.removeAttr("tabindex");
				if ($f.attr("aria-hidden") === "true") $f.removeAttr("aria-hidden");
			});
		});
	},

	unload: function unload($section) {
		var $slider = $section.find(".flickity-enabled");
		if ($slider.length) {
			this._clearFocusState($slider);
			$slider.flickity("destroy");
		}
		$(window).off("resize.featuredCollection");
		$(window).off("load.featuredCollection");
	},
};
